import React from "react"


const Pagenotfound=()=>{
    return(
        <div>
            <h1>Pagenotfound Page</h1>
        </div>
    )
}

export default Pagenotfound